import React, { useState, useEffect } from 'react'
import extraImg from '../assets/empty-cart.gif';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

const OrderDelivered = ({ userData }) => {
  const [orders, setOrders] = useState([]);
  const [excorders, setExcOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-assigned-order/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedOrders = data.sort((a, b) => b.id - a.id);
          setOrders(sortedOrders);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    const fetchExcOrders = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-exchange-assigned-order/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedOrders = data.sort((a, b) => b.id - a.id);
          setExcOrders(sortedOrders);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchExcOrders();
    fetchOrders();
  }, [userData.id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // Merge delivered orders and exchange orders and filter/search
const mergedDeliveredOrders = [
  ...orders
    .filter(order => order.order_status === 'Delivered')
    .filter(order => {
      // Check customer_name or formatted order_date match searchQuery
      const isDateMatch = formatDate(order.order_date).toLowerCase().includes(searchQuery.toLowerCase());
      const isCustomerMatch = order.customer_name.toLowerCase().includes(searchQuery.toLowerCase());
      return isCustomerMatch || isDateMatch;
    })
    .map(order => ({
      id: order.id,
      type: 'normal',
      date: order.order_date,
      customer_name: order.customer_name,
      customer_mobile: order.customer_mobile,
      customer_address: `${order.customer_address} ${order.customer_city} ${order.customer_state} ${order.customer_pincode}`,
      payment_mode: order.payment_mode,
      payment_status: order.payment_status,
      total_amount: order.total_amount,
      items: JSON.parse(order.order_items),
    })),

  ...excorders
    .filter(order => order.req_status === 'Delivered')
    .filter(order => {
      // Check customer_name or formatted exchange delivery date
      const isDateMatch = formatDate(order.req_on).toLowerCase().includes(searchQuery.toLowerCase());
      const isCustomerMatch = order.customer_name.toLowerCase().includes(searchQuery.toLowerCase());
      return isCustomerMatch || isDateMatch;
    })
    .map(order => {
      const orderItems = JSON.parse(order.ex_items);
      const grandTotal = orderItems.reduce((acc, item) => acc + Number(item.total_price), 0);

      return {
        id: order.id,
        type: 'exchange',
        date: order.req_on,
        customer_name: order.customer_name,
        customer_mobile: order.customer_mobile,
        customer_address: `${order.customer_address} ${order.customer_city} ${order.customer_state} ${order.customer_pincode}`,
        total_amount: grandTotal,
        items: orderItems.map(item => ({
          product_name: item.name,
          quantity: item.qty,
          price: item.price,
          total_price: item.total_price,
          image: item.image || '',
        })),
      };
    }),
].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>

          <div className='d-flex'>
            <p className='sec-heading'>Orders Delivered</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>History</span>
          </div>

          <div className="text-start mb-4">
            <input
              type="text"
              className="form-input rounded border-0"
              placeholder="🎯 Search order here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {mergedDeliveredOrders.length > 0 ? (
            mergedDeliveredOrders.map(order => (
              <div className='my-3' key={`${order.type}-${order.id}`}>
                <div className='order-area'>
                  <p className='fw-semibold'>
                    {order.type === 'exchange' ? 'Exchange Delivered on ' : 'Order placed on '}
                    {formatDate(order.date)}
                  </p>
                  <p className='text-muted fw-semibold para-text'>
                    Customer Name: {order.customer_name}<br />
                    Mobile No: {order.customer_mobile}<br />
                    Address: {order.customer_address}
                  </p>

                  <Swiper
                    spaceBetween={20}
                    slidesPerView={order.type === 'exchange' ? 6 : 8}
                    modules={[Navigation]}
                    loop={true}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    breakpoints={{
                      0: { slidesPerView: 3 },
                      768: { slidesPerView: order.type === 'exchange' ? 3 : 4 },
                      992: { slidesPerView: order.type === 'exchange' ? 6 : 8 },
                    }}
                  >
                    {order.items.length > 0 ? (
                      order.items.map((item, index) => (
                        <React.Fragment key={index}>
                          <hr />
                          <SwiperSlide className='mt-2'>
                            {item.image && <img src={`https://api.kcmstore.in/sUploads/${item.image}`} className='img-fluid' alt='Product' />}
                            <p className='mt-2 mb-0 para-text fw-semibold'>{item.product_name}</p>
                            <span className='text-muted para-text'>
                              {item.quantity} Item | Price ₹{item.price || item.product_price} | Total ₹{item.total_price || (item.product_price * item.quantity)}
                            </span>
                          </SwiperSlide>
                        </React.Fragment>
                      ))
                    ) : (
                      <p>No items in this order</p>
                    )}
                  </Swiper>

                  {order.type === 'normal' && (
                    <p className='mt-3 text-muted fw-semibold para-text text-capitalize'>
                      Payment Mode: {order.payment_mode}<br />
                      Payment Status: {order.payment_status}
                    </p>
                  )}
                  <p className='text-muted fw-semibold'>Order Total ₹ {order.total_amount}</p>
                  {order.type === 'exchange' && (
                    <p className='text-muted fw-semibold'>This Order Exchange has been Delivered</p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className='text-center'>
              <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='No Orders' />
              <p>No Orders Delivered yet</p>
            </div>
          )}

        </div>
      </section>
    </>
  )
}

export default OrderDelivered;
